import { isEdge, isNode } from 'react-flow-renderer';

export const filterNodes = (elements) => elements.filter((el) => isNode(el));
export const filterEdges = (elements) => elements.filter((el) => isEdge(el));
